import axios from './axios';

/**
 * Driver Deposit API Functions
 * Handles all CRUD operations for driver petty cash deposits
 * Manages API calls to backend driver deposit endpoints
 */

// Get all driver deposits from backend API
export const getAllDriverDeposits = async () => {
  const response = await axios.get('/admin/driver-deposits');
  return response.data.data;
};

// Create new driver deposit with optional file upload support
export const addDriverDeposit = async (deposit) => {
  let config = {};
  if (deposit instanceof FormData) {
    config.headers = { 'Content-Type': 'multipart/form-data' };
  }
  const response = await axios.post('/admin/driver-deposits', deposit, config);
  return response.data.data;
};

// Update existing driver deposit record
export const updateDriverDeposit = async (id, deposit) => {
  // If already FormData, use it. Otherwise convert object to FormData
  const fd = deposit instanceof FormData ? deposit : new FormData();

  if (!(deposit instanceof FormData)) {
    Object.entries(deposit || {}).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      fd.append(key, String(value));
    });
  }

  // Laravel method spoofing for PUT (file upload safe)
  fd.append("_method", "PUT");

  const response = await axios.post(`/admin/driver-deposits/${id}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data.data;
};


// Delete driver deposit record by ID
export const deleteDriverDeposit = async (id) => {
  const response = await axios.delete(`/admin/driver-deposits/${id}`);
  return response.data;
};

// Get specific driver deposit by ID with details
export const getDriverDepositById = async (id) => {
  const response = await axios.get(`/admin/driver-deposits/${id}`);
  return response.data.data;
}; 